import { lazy } from 'react';
const Restaurants = lazy(() => import('../components/restaurants/restaurants'));
const CustomerRegistration = lazy(() => import('../components/customerregistration/customerregistration'));
const CustomerSongRequest = lazy(() => import('../components/customersongrequest/customersongrequest'));
const Dashboard = lazy(() => import('../components/dashboard/dashboard1/dashboard'));
const RestaurantDashboard = lazy(() => import('../components/dashboard/restaurantdashboard/restaurantdashboard'));
const Roles = lazy(() => import('../components/roles/roles'));
const Users = lazy(() => import('../components/users/users'));
const MusicAPIConfiguration = lazy(() => import('../components/settings/musicconfiguration'));
const PaymentGateway = lazy(() => import('../components/settings/paymentgateway'));
const Event = lazy(() => import('../components/events/events'));
const HostDashboard = lazy(() => import('../components/dashboard/hostdashboard/hostdashboard'));
const ClubnexusGate = lazy(() => import('../components/clubnexusgate/clubnexusgate'));
const Promotions = lazy(() => import('../components/promotions/promotions'));
const LiveEvent = lazy(() => import('../components/liveevent/liveevent'));
const PostEvent = lazy(() => import('../components/postevent/postevent'));
const PostEventDetails = lazy(() => import('../components/postevent/posteventdetails'));
const Loyalty = lazy(() => import('../components/loyalty/loyalty'));
const Profile = lazy(() => import('../components/profile/profile'));
// const ClubProfile = lazy(() => import('../components/pages/authentication/clubprofile/clubprofile'));
const DjDashboard = lazy(() => import('../components/pages/authentication/dashboard/djDashboard'));
const DjClubSelectionDashboard = lazy(() => import('../components/pages/authentication/dashboard/clubSelectionForDj'));
const DJProfile = lazy(() => import('../components/pages/authentication/djprofile/djprofile'));
const ProfileCompletion = lazy(() => import('../components/pages/authentication/profileCompletion/profileCompletion'));
const TipHistory = lazy(() => import('../components/tiphistory/tiphistory'));



export const Routingdata = [
  { path: `${import.meta.env.BASE_URL}restaurants`, element: <Restaurants /> },
  { path: `${import.meta.env.BASE_URL}customerregistration`, element: <CustomerRegistration /> },
  { path: `${import.meta.env.BASE_URL}customersongrequest`, element: <CustomerSongRequest /> },
  { path: `${import.meta.env.BASE_URL}admin_dashboard`, element: <Dashboard /> },
  { path: `${import.meta.env.BASE_URL}restaurantdashboard`, element: <RestaurantDashboard /> },
  { path: `${import.meta.env.BASE_URL}roles`, element: <Roles /> },
  { path: `${import.meta.env.BASE_URL}users`, element: <Users /> },
  { path: `${import.meta.env.BASE_URL}musicconfiguration`, element: <MusicAPIConfiguration /> },
  { path: `${import.meta.env.BASE_URL}paymentgateway`, element: <PaymentGateway /> },
  { path: `${import.meta.env.BASE_URL}events`, element: <Event /> },
  { path: `${import.meta.env.BASE_URL}hostdashboard`, element: <HostDashboard /> },
  { path: `${import.meta.env.BASE_URL}clubnexusgate`, element: <ClubnexusGate /> },
  { path: `${import.meta.env.BASE_URL}promotions`, element: <Promotions /> },
  { path: `${import.meta.env.BASE_URL}liveevent`, element: <LiveEvent /> },
  { path: `${import.meta.env.BASE_URL}postevent`, element: <PostEvent /> },
  { path: `${import.meta.env.BASE_URL}posteventdetails`, element: <PostEventDetails /> },
  { path: `${import.meta.env.BASE_URL}loyalty`, element: <Loyalty /> },
  { path: `${import.meta.env.BASE_URL}profile`, element: <Profile /> },
  { path: `${import.meta.env.BASE_URL}dashboard`, element: <DjDashboard /> },
  { path: `${import.meta.env.BASE_URL}djdashboard`, element: <DjClubSelectionDashboard /> },
  // { path: `${import.meta.env.BASE_URL}clubprofile`, element: <ClubProfile /> },
    { path: `${import.meta.env.BASE_URL}djprofile`, element: <DJProfile /> },
    { path: `${import.meta.env.BASE_URL}profilecompletion`, element: <ProfileCompletion /> },
    { path: `${import.meta.env.BASE_URL}tiphistory`, element: <TipHistory /> },

];

export const Sidebarcomponents = [
  { path: `${import.meta.env.BASE_URL}pages/authentication/dashboard`, title: 'Dashboard' },
  { path: `${import.meta.env.BASE_URL}pages/authentication/sigin`, title: "Sign In" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/sigup`, title: "Sign Up" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/forgotpassword`, title: "Forgot Password" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/resetpassword`, title: "Reset Password" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/complaintstatus`, title: "ComplaintStatus" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/clubprofile`, title: "ClubProfile" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/underconstruction`, title: "UnderConstruction" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/404error`, title: "404 Error" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/500error`, title: "500 Error" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/501error`, title: "501 Error" },
  { path: `${import.meta.env.BASE_URL}pages/authentication/privacypolicy`, title: "Privacy Policy" },
];
